import { Html5QrcodeScanner, Html5QrcodeScanType } from "html5-qrcode";
import { useEffect } from "react";

function QRReader({ onSuccess }) {
  function onScanSuccess(decodedText, decodedResult) {
    onSuccess(decodedText);
  }

  function onScanFailure(error) {
    alert(`Code scan error = ${error}`);
  }

  useEffect(() => {
    let html5QrcodeScanner = new Html5QrcodeScanner(
      "reader",
      {
        fps: 10,
        qrbox: { width: 250, height: 250 },
        supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_FILE],
      },
      /* verbose= */ false
    );
    html5QrcodeScanner.render(onScanSuccess, onScanFailure);
  }, []);

  return (
    <div>
      <div id="reader" width="600px"></div>
    </div>
  );
}

export default QRReader;
